import '../stylesheets/ViewHotspot.css';
import { Icon, Button, Input, Segment } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useState, useEffect, useRef, ReactDOM } from 'react';
import Draggable from 'react-draggable'; // The default

const ViewHotspot = ({ viewpointComponent, name, groupIndex, index, inViewpoint, linkTo, moveToViewpoint }) => {
    
    const hotspotNameAlwaysVisible = !(["LVL", "Sustainable production", "Veneer peeling"].includes(name))
    const [dragActive, setDragActive] = useState(false)
    const [hotspotNameVisible, setHotspotNameVisible] = useState(false)
    const [componentPosition, setComponentPosition] = useState({})
    const [screenCoords, setScreenCoords] = useState({
        x: viewpointComponent?.data.screenCoordX, 
        y: viewpointComponent?.data.screenCoordY,
        objectOffScreen: false
    })

    const buttonRef = useRef(null);
    
    const createScreenCoordUpdateRef = () => {
        window.ViewHotspotRefs[groupIndex][index] = () => {
            if (screenCoords.x === viewpointComponent?.data.screenCoordX
            && screenCoords.y === viewpointComponent?.data.screenCoordY) {
                return;
            }
            setScreenCoords({ 
                x: viewpointComponent?.data.screenCoordX || 0,
                y: viewpointComponent?.data.screenCoordY || 0,
                objectOffScreen: viewpointComponent?.data.objectOffScreen
            });
        }
    }
    createScreenCoordUpdateRef();

    useEffect( () => {
        createScreenCoordUpdateRef();

        setScreenCoords({ 
            x: viewpointComponent?.data.screenCoordX || 0,
            y: viewpointComponent?.data.screenCoordY || 0,
            objectOffScreen: viewpointComponent?.data.objectOffScreen
        });

        // Cleanup setScreenCoords reference when component unmounted
        return () => {
            window.ViewHotspotRefs[groupIndex][index] = null;
        }
    }, [viewpointComponent]);

    
    const changeView = () => {
        moveToViewpoint(linkTo, inViewpoint);
    }

    const calculatePosition = () => {
        viewpointComponent.getUpdatedPosition()?.then( (res) => {
            setComponentPosition(res);
        })
    }

    const showHotspotName = () => {
        setHotspotNameVisible(true)
    }
    
    const hideHotspotName = () => {
        setHotspotNameVisible(false)
    }

    const generateButtonStyle = (buttonRef) => {
        // const elementWidth = buttonRef?.current?.ref?.current?.offsetWidth;
        const elementWidth = 50;
        const moveLength = -elementWidth;
        const timing = 200;
        return {
            display: 'inline-block',
            backfaceVisibility: 'hidden',
            transform: (hotspotNameVisible) ?
                `translate(${moveLength}px)`
                : `translate(0px)`,
            transition: `transform ${timing}ms`,
        }
    };
    
    const generateViewpointStyle = () => {
        return { 
            left: (screenCoords.objectOffScreen) ? -100 : screenCoords.x, 
            right: 'auto', 
            top: (screenCoords.objectOffScreen) ? -100 : screenCoords.y,
            bottom: 'auto',
            zIndex: 1001,
            position: 'fixed',
            display: 'block'
        }
    }

    return (
        (window.debug) 
        ? <Draggable>
            <div style={generateViewpointStyle()}>
                <div className="catch-pointer-events">
                    <Button 
                        icon labelPosition="right"
                        className="catch-pointer-events hotspot-button" 
                        color="blue" size='small' 
                        onClick={dragActive ? () => console.log("debug mode active") : changeView}>
                        {name}
                        <Icon name="street view" size="large"></Icon>
                    </Button>
                </div>
                <br/>
                <Button onClick={() => setDragActive(!dragActive)} size='small' className="catch-pointer-events">disable click</Button>
                <Button onClick={() => calculatePosition()} size='small' className="catch-pointer-events">calcPos</Button>
                <Input
                    className="catch-pointer-events"
                    action={{
                        color: 'teal',
                        labelPosition: 'right'
                    }}
                    value={JSON.stringify({x: componentPosition?.x, y: componentPosition?.y, z: componentPosition?.z})}
                />
            </div>
        </Draggable>
        : <div style={generateViewpointStyle()}>
            <div className="catch-pointer-events">
                 {
                    (hotspotNameVisible || hotspotNameAlwaysVisible) ?
                    <Button 
                        ref={buttonRef}
                        icon labelPosition="right" 
                        className="catch-pointer-events hotspot-button" 
                        color="blue" size='large' 
                        onClick={changeView}
                        onMouseEnter={(hotspotNameAlwaysVisible) ? null : showHotspotName}
                        onMouseLeave={(hotspotNameAlwaysVisible) ? null : hideHotspotName}
                        style={generateButtonStyle(buttonRef)}
                    >
                        {name}
                        <Icon name="street view" size="large"></Icon>
                    </Button>
                    : <Button 
                        ref={buttonRef}
                        icon 
                        className="catch-pointer-events hotspot-button" 
                        color="blue" size='large' 
                        onClick={changeView}
                        onMouseEnter={showHotspotName}
                        onMouseLeave={hideHotspotName}
                        style={generateButtonStyle(buttonRef)}
                    >
                        <Icon name="street view" size="large"></Icon>
                    </Button>
                }
            </div>
            <br/>
        </div>
    )
};

ViewHotspot.propTypes = {
    viewpointComponent: PropTypes.object,
    name: PropTypes.string,
    groupIndex: PropTypes.number,
    index: PropTypes.number,
    inViewpoint: PropTypes.string,
    linkTo: PropTypes.string,
    moveToViewpoint: PropTypes.func
}

export default ViewHotspot;